interface InputLabelProps {
  label: string;
  name?: string;
  required?: boolean;
  errorMessage?: string;
}

export const InputLabel = ({
  label,
  name,
  required,
  errorMessage,
}: InputLabelProps) => {
  return (
    <label htmlFor={name} className="input-label">
      {label} {required && <span>*</span>}
      {errorMessage && <small className="p-error ml-2">{errorMessage}</small>}
    </label>
  );
};
